import { all, fork } from 'redux-saga/effects';

import globalSaga from '@stores/global/saga';
import documentSaga from '@stores/document/saga';
import authSaga from '@stores/auth/saga';
import eRecruitmentSaga from '@stores/eRecruitment/saga';
import myProfileSaga from '@stores/myprofile/saga.js';
import feeSaga from '@stores/fee/saga.js';
import policySaga from '@stores/policy/saga.js';
import contractSaga from '@stores/contract/saga';
import k2ReportSaga from '@stores/k2Report/saga.js';
import payslipSaga from '@stores/payslip/saga';
import eRecognitionSaga from '@stores/eRecognition/saga';
import clientSaga from '@stores/client/saga.js';
import salesReportSaga from '@stores/salesReport/saga.js';
import trajetReportSaga from '@stores/trajetReport/saga.js';
import commonSaga from '@stores/common/saga.js';
import leadSaga from '@stores/lead/saga.js';
import ePromotionSaga from '@stores/ePromotion/saga.js';
import opmSaga from '@stores/opm/saga.js';

export default function* rootSaga() {
  yield all([fork(globalSaga)]);
  yield all([fork(documentSaga)]);
  yield all([fork(authSaga)]);
  yield all([fork(myProfileSaga)]);
  yield all([fork(eRecruitmentSaga)]);
  yield all([fork(ePromotionSaga)]);
  yield all([fork(feeSaga)]);
  yield all([fork(policySaga)]);
  yield all([fork(contractSaga)]);
  yield all([fork(k2ReportSaga)]);
  yield all([fork(payslipSaga)]);
  yield all([fork(eRecognitionSaga)]);
  yield all([fork(clientSaga)]);
  yield all([fork(salesReportSaga)]);
  yield all([fork(commonSaga)]);
  yield all([fork(leadSaga)]);
  yield all([fork(trajetReportSaga)]);
  yield all([fork(opmSaga)]);
}
